import * as React from 'react';
import { ScheduleEntry } from '../../../domain/ScheduleEntry';
import { ScheduleWeek } from '../../../domain/ScheduleWeek';
import ScheduleTableBlock from './ScheduleTableBlock';
import ScheduleTableBlockMobile from './mobile/ScheduleTableBlockMobile';
import { ScheduleView } from '../ScheduleContent';

interface Props {
    name: string;
    week?: ScheduleWeek;
    entries: ScheduleEntry[];
    assigned: number[];
    editable?: boolean;
    view: ScheduleView;
    onEntryUpdate?: (entry: ScheduleEntry) => void;
    onEntryEdit?: (entry: ScheduleEntry) => void;
    onPublisherScheduleHistory?: (entry: ScheduleEntry) => void;
    onEntryAssignmentHistory?: (entry: ScheduleEntry) => void;
    onEntrySendNotification?: (entry: ScheduleEntry) => void;
    onEntryDownload?: (entry: ScheduleEntry) => void;
    onEntryAutoArrange?: (entry: ScheduleEntry) => void;
}

export interface EntryObject {
    name: string;
    entries: ScheduleEntry[];
}

const ScheduleTableEntry = (props: Props) => {
    const [entries, setEntries] = React.useState<EntryObject[]>([]);

    React.useEffect(() => {
        const merged: EntryObject[] = [];
        props.entries.forEach(entry => {
            const same = merged.find(obj => obj.name === entry.name);
            if (same) {
                same.entries.push(entry);
            } else {
                const obj = { name: entry.name, entries: [] } as EntryObject;
                obj.entries.push(entry);
                merged.push(obj)
            }
        });
        setEntries(merged);
    }, [props.entries]);

    const downloadHandler = props.name === 'apply-yourself' ? props.onEntryDownload : undefined;
    const commonProps = { ...props, entries, onEntryDownload: downloadHandler };

    return props.view === 'fit'
        ? <ScheduleTableBlockMobile {...commonProps} />
        : <ScheduleTableBlock {...commonProps} />
};

export default ScheduleTableEntry;
